import { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";

import { isLocalhost } from "~/util/env-utils";

const DevOnlyMarkdown = lazy(() =>
  import("./dev-only-markdown").then((module) => ({
    default: module.DevOnlyMarkdown,
  })),
);

const DevOnlyTextarea = lazy(() =>
  import("./dev-only-textarea").then((module) => ({
    default: module.DevOnlyTextarea,
  })),
);

const DevOnlyMicrophone = lazy(() =>
  import("./dev-only-microphone").then((module) => ({
    default: module.DevOnlyMicrophone,
  })),
);

const DevOnlyIframe = lazy(() =>
  import("./dev-only-iframe").then((module) => ({
    default: module.DevOnlyIframe,
  })),
);

const DevOnlyDatepicker = lazy(() =>
  import("./dev-only-datepicker").then((module) => ({
    default: module.DevOnlyDatepicker,
  })),
);

const routes = {
  markdown: (
    <Suspense fallback={<div>{"Loading markdown..."}</div>}>
      <DevOnlyMarkdown />
    </Suspense>
  ),
  textarea: (
    <Suspense fallback={<div>{"Loading textarea..."}</div>}>
      <DevOnlyTextarea />
    </Suspense>
  ),
  microphone: (
    <Suspense fallback={<div>{"Loading microphone..."}</div>}>
      <DevOnlyMicrophone />
    </Suspense>
  ),
  iframe: (
    <Suspense fallback={<div>{"Loading iframe..."}</div>}>
      <DevOnlyIframe />
    </Suspense>
  ),
  datepicker: (
    <Suspense fallback={<div>{"Loading datetime..."}</div>}>
      <DevOnlyDatepicker />
    </Suspense>
  ),
};

export const createDevOnlyRouter = (): RouteObject[] => {
  if (!isLocalhost) {
    return [];
  }

  return Object.entries(routes).map(([slug, element]) => ({
    path: `/devonly/${slug}`,
    element,
  }));
};
